/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
import React, { PureComponent } from 'react';
import bindMethods from 'auto-bind';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// eslint-disable-next-line
import WaveSurfer from 'wavesurfer.js';

import 'video.js/dist/video-js.css';
import videojs from 'video.js';

import 'videojs-wavesurfer/dist/css/videojs.wavesurfer.css';
// eslint-disable-next-line
import Wavesurfer from 'videojs-wavesurfer/dist/videojs.wavesurfer';
import styled from 'styled-components';
import { videoJsOptions, waveFormJsOptions } from '../VirtualClipper/constants/videoJsOptions';
import generatePreviewUrl from '../../utils/generatePreviewUrl';

const PlayerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

class AudioContent extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  componentDidMount() {
    const { sourceUrl } = this.props;
    const mixin = { ...videoJsOptions, ...waveFormJsOptions };

    // instantiate Video.js
    this.player = videojs(this.audioNode, mixin, () => {
      const pathName = new URL(sourceUrl).pathname;
      const mime = pathName.indexOf('.wav') > -1
        ? 'audio/wav'
        : 'audio/mpeg';

      console.log(`[QA] Audio player will play ${mime} from ${sourceUrl}.`);

      // load file
      this.player.src({ src: sourceUrl, type: mime });

      // error handling
      this.player.on('error', (element, error) => {
        // this.player.reset();
        console.error(error);
      });
    });
  }

  componentDidUpdate(prevProps) {
    const { sourceUrl, rawAssetDetails: { previewImageId } } = this.props;

    if (sourceUrl) {
      if (sourceUrl !== prevProps.sourceUrl) {
        const pathName = new URL(sourceUrl).pathname;
        const mime = pathName.indexOf('.wav') > -1
          ? 'audio/wav'
          : 'audio/mpeg';

        this.player.src({ src: sourceUrl, type: mime });
        console.log(`[QA] Audio player will play ${mime} from ${sourceUrl}.`);

        const posterUrl = generatePreviewUrl(previewImageId);
        this.player.poster(posterUrl);
      }
    } else {
      console.log('[QA] Audio player source was empty.');
    }
  }

  render() {
    return (
      <PlayerContainer data-vjs-player>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <audio
          id="AssetDetails.MediaContent.AudioContent"
          /* eslint-disable-next-line no-return-assign */
          ref={(node) => (this.audioNode = node)}
          className="video-js vjs-16-9 vjs-big-play-centered"
        />
      </PlayerContainer>
    );
  }
}

AudioContent.propTypes = {
  sourceUrl: PropTypes.string.isRequired, // supplied from MediaContent
  rawAssetDetails: PropTypes.object.isRequired, // supplied from Redux
};

const mapStateToProps = (state) => ({
  rawAssetDetails: state.rawAssetDetails,
});

export default connect(mapStateToProps)(AudioContent);
